import React from 'react';
import ISRMainPage from '../Pages/ISRMainPage';

// Bug 12453: the model name route param is URL-encoded by the navigation callers
// (names can contain #, %, spaces, …). Decode it for display; fall back to the raw
// value if it isn't valid percent-encoding (e.g. an old/bookmarked URL).
const safeDecode = (value?: string) => {
    if (!value) return value;
    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
};

const ISRMainProvider = (props:any) => {
    const { params } = props.match;
    return (
        <React.Fragment>
            <ISRMainPage isrName={safeDecode(params?.name)} isrId={params?.id} />
        </React.Fragment>
    );
}

export default ISRMainProvider;